// Shared with the customer policy-changes preview (parse-requested-changes.js), which
// deliberately DOES show make/model on an added or removed car — keep this list to the
// fields both surfaces agree are noise, and put modal-only entries in the modal's own
// pathsToOmit.
export const CAR_DIFF_PATHS_TO_OMIT = ['hash', 'image', 'symbol', 'assignedDriver'];

// Each entry hides any path segment that STARTS WITH it, so 'driversLicense'
// covers the whole family (driversLicenseNumber, driversLicenseState, …).
export const SENSITIVE_DIFF_PATHS_TO_OMIT = [
  'ssn',
  'dob',
  'dateOfBirth',
  'driversLicense',
  'savedDriversLicense',
  'driverLicense'
];

const SENSITIVE_PREFIXES = SENSITIVE_DIFF_PATHS_TO_OMIT.map((field) => field.toLowerCase());

export const isSensitiveField = (field) => {
  const lowered = String(field).toLowerCase();
  return SENSITIVE_PREFIXES.some((prefix) => lowered.startsWith(prefix));
};

// Named noise under insuranceScore, in two groups:
//
//  - steps / model / fillDate — scoring-model breakdown and pull bookkeeping.
//  - homeTotal / autoTotal — the score itself, but redundant: credit.ts writes the flat
//    insuranceScoreHomeTotal / insuranceScoreAutoTotal alongside them, and those are not
//    nested so they were always the rows a reader saw.
//
// A deny-list rather than "everything except total" on purpose. A real Transunion pull
// never writes `total` (packages/rater/src/credit.ts sets steps, autoTotal, homeTotal,
// autoNoScore, homeNoScore, thinFile, useAltCredit and the reason codes; only the
// DEFAULTED_INSURANCE_SCORE paths set `total`), so allow-listing it hid the flags that
// explain WHY a score moved — autoNoScore/homeNoScore, thinFile, defaulted and the
// adverse-action reason codes. Those stay, and a new sub-field shows up and gets judged
// instead of disappearing silently.
export const OFFER_DIFF_PATTERNS_TO_OMIT = [
  /^quote\.buyUp(\.|$)/i,
  /insuranceScore\.(steps|model|fillDate|homeTotal|autoTotal)(\.|$)/i,
  /^offerings\.\d+\.(kind|name)$/i
];

// True when a flattened diff path (e.g. 'quote.drivers.0.dateOfBirth') should be
// omitted. The sensitive list and noise patterns above always apply;
// extraPathsToOmit are feature-specific entries matched as case-insensitive substrings.
export const containsOmittedPath = (path, extraPathsToOmit = []) => {
  const lowerPath = path.toLowerCase();
  const segments = lowerPath.split('.');
  if (segments.some(isSensitiveField)) {
    return true;
  }
  if (OFFER_DIFF_PATTERNS_TO_OMIT.some((pattern) => pattern.test(path))) {
    return true;
  }
  return extraPathsToOmit.some((omit) => lowerPath.includes(omit.toLowerCase()));
};
